// TODO
export const OG = (): JSX.Element => {
  return <></>;
};
